export default __webpack_public_path__ + "static/media/blog-40-1.2699d203.jpg";